const Routes = [
  {
    path: '/sell_in_proposal',
    name: 'SellInProposal',
    component: () => import('@/app/sell_in_proposal/TheSellInProposal'),
    redirect: '/sell_in_proposal/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/sell_in_proposal/views/Index')
      }
    ]
  }
]
export default Routes



// WEBPACK FOOTER //
// ./src/app/sell_in_proposal/Routes.js